import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import file_icon from "../assets/img/file-icon.png";
import { useSelector } from "react-redux";
import UploadFileButton from "../component/UploadFileButton";

export default function PreviewFile({ detail, onSelect, onRemove, itemClass, isEdit = true }) { // Thêm onRemove vào props
    const [showModal, setShowModal] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [fileType, setFileType] = useState("");

    const isImageByExtension = (url) => {
        return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url.toLowerCase());
    };
    const handleClose = () => setShowModal(false);
    const handlePrint = () => {
        const printWindow = window.open(previewUrl, "_blank");
        if (printWindow) printWindow.print();
    };
    const handlePreview = (url) => {
        const lower = url.toLowerCase();
        if (isImageByExtension(lower)) setFileType("image");
        else if (lower.endsWith(".pdf")) setFileType("pdf");
        else if (/\.(doc|docx|xls|xlsx)$/.test(lower)) setFileType("office");
        else setFileType("other");
        setPreviewUrl(url);
        setShowModal(true);
    };

    const files = detail?.list_file || [];

    return (
        <>
            <div className="row">
                {files.map((itemFile, key) => (
                    <div className={itemClass ? itemClass : "col-12 col-sm-6 mb-3"} key={key}>
                        {/* Thêm position-relative để đặt nút xóa lên trên */}
                        <div className="w-100 wrapper border rounded p-2 text-center position-relative" style={{ minHeight: '150px' }}>

                            {/* NÚT XÓA FILE */}
                            {isEdit ? <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute"
                                style={{ top: '5px', right: '5px', zIndex: 10, borderRadius: '50%', width: '25px', height: '25px', padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                onClick={() => {
                                    if (window.confirm("Bạn có chắc chắn muốn xóa file này?")) {
                                        onRemove(key);
                                    }
                                }}
                            >
                                <span className="fas fa-trash-alt"></span>
                            </button> : ''}


                            <div
                                className="d-flex align-items-center justify-content-center mb-2"
                                style={{ height: '100px', cursor: 'pointer' }}
                                onClick={() => handlePreview(itemFile)}
                            >
                                <img
                                    src={isImageByExtension(itemFile) ? itemFile : file_icon}
                                    alt="preview"
                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                />
                            </div>
                            <div className="w-100 position-relative" style={{overflow:"hidden",height:"25px"}}>
                                <p className="text-right mb-0 small position-absolute" style={{right:0,whiteSpace: "nowrap",fontSize:11}} title={itemFile}>
                                    {itemFile.split('/').pop()}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}
                {isEdit ?
                    <UploadFileButton
                        classGroup={itemClass ? itemClass : "col-12 col-sm-6 mb-3"}
                        classButton="w-100 h-100 btn btn-outline-info d-flex flex-column align-items-center justify-content-center"
                        defaultValue={files}
                        // Nhớ dùng đúng tên onSellect (2 chữ l) của component gốc
                        onSellect={(val) => onSelect(val)}
                        multiple={true}
                        onlytype="*"
                    />
                    : ""}
            </div>


            {/* Modal Preview */}
            <Modal show={showModal} onHide={handleClose} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="w-100 d-flex justify-content-between align-items-center pr-4">
                        <span className="h6 mb-0">Xem chi tiết tài liệu</span>
                        <button className="btn btn-sm btn-primary" onClick={handlePrint}>
                            <i className="bi bi-box-arrow-up-right me-1"></i> Mở trong tab mới
                        </button>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-0" style={{ height: "80vh" }}>
                    {fileType === "image" ? (
                        <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                            <img src={previewUrl} alt="" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                        </div>
                    ) : (fileType === "pdf" || fileType === "office") ? (
                        <iframe
                            src={fileType === "office"
                                ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(previewUrl)}`
                                : previewUrl
                            }
                            width="100%"
                            height="100%"
                            style={{ border: "none" }}
                            title="file preview"
                        ></iframe>
                    ) : (
                        <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                            <p>Định dạng này không hỗ trợ xem trực tiếp.</p>
                            <a href={previewUrl} download className="btn btn-success">
                                <i className="bi bi-download"></i> Tải file về máy
                            </a>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}